import React from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { unitFormValidationSchema } from "../../utils/validation";
import { useFormik } from "formik";

const UnitFormModal = ({ handleFormSubmit, open, handleClose, title, t,direction }) => {
  const formik = useFormik({
    initialValues: {
      unitNameEnglish: "",
      unitNameArabic: "",
      descriptionEnglish: "",
      descriptionArabic: "",
    },
    validationSchema: unitFormValidationSchema(t),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      handleFormSubmit(values);
      formik.resetForm(); // Reset after successful submit
      handleClose();
    },
  });
  const fields = [
    { 
      label: t.unitNameEnglish, 
      name: 'unitNameEnglish', 
    
    },
    { 
      label: t.unitNameArabic, 
      name: 'unitNameArabic', 
    
    },
    { 
      label: t.descriptionEnglish, 
      name: 'descriptionEnglish', 
   
    },
    { 
      label: t.descriptionArabic, 
      name: 'descriptionArabic', 
     
    }
  ];
  const handleModalClose = () => {
    handleClose();
    formik.resetForm(); // Reset form when modal closes
  };
  const handleFormSubmitInternal = (event) => {
    event.preventDefault();
    handleFormSubmit(formik.values);
  };

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          backdropFilter: "blur(5px)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          padding: { xs: "16px", md: "32px" },
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.7)",
          width: { xs: "90%", sm: "80%", md: "500px", lg: "600px" },
          borderRadius: 2,
          maxHeight: { xs: "100vh", md: "auto" },
          overflowY: "auto", // Enable vertical scrolling
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 500, color: "#0F548B", textAlign: "center", mb: 2 }}
        >
          {title}
        </Typography>
        <form onSubmit={formik.handleSubmit}>
        {fields.map((field, index) => (
            <div key={index}>
              <Typography
                variant="h6"
                sx={{ color: "#6C757D", fontSize: "16px", mt: 2, mb: 1 }}
              >
                {field.label}
              </Typography>
              <TextField
                fullWidth
                dir={direction}
                name={field.name}
                value={formik.values[field.name]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur} // Handle blur to update `touched` state
                error={formik.touched[field.name] && !!formik.errors[field.name]} // Show error if touched and invalid
                helperText={formik.touched[field.name] && formik.errors[field.name]}
              />
                
            </div>
          ))}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "16px",
              flexDirection: { xs: "column", md: "row" },
              mt: 2,
            }}
          >
            <Button
              type="button"
              variant="contained"
              fullWidth
              onClick={handleModalClose}
              sx={{
                backgroundColor: "var(--back-color)",
                padding: { xs: "10px 0", sm: "10px 40px" },
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              {t.cancel}
            </Button>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "var(--primary-color)",
                padding: { xs: "10px 0", sm: "10px 40px" },
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
              }}
              disabled={!formik.isValid || !formik.dirty}
            >
              {t.submit}
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default UnitFormModal;
